module.exports = __webpack_public_path__ + "static/media/play-logo.71a67ed4.svg";